import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type UnauthorizedError = FetchBaseQueryError & { status: 401 };
export type ForbiddenError = FetchBaseQueryError & { status: 403 };
export type NotFoundError = FetchBaseQueryError & { status: 404 };
export type InternalServerError = FetchBaseQueryError & { status: 500 };

// Generic guard
export const isErrorStatus = <S extends number>(
  error: FetchBaseQueryError | undefined,
  status: S,
): error is FetchBaseQueryError & { status: S } => !!error && error.status === status;

// Specific guards
export const isUnauthorizedError = (error: FetchBaseQueryError | undefined): error is UnauthorizedError =>
  isErrorStatus(error, 401);

export const isForbiddenError = (error: FetchBaseQueryError | undefined): error is ForbiddenError =>
  isErrorStatus(error, 403);

export const isNotFoundError = (error: FetchBaseQueryError | undefined): error is NotFoundError =>
  isErrorStatus(error, 404);

export const isInternalServerError = (error: FetchBaseQueryError | undefined): error is InternalServerError =>
  isErrorStatus(error, 500);

export const isAbortError = (error: any): boolean => {
  return error?.error?.name === 'AbortError' || error?.name === 'AbortError' || error?.message === 'Aborted';
};
